import { render, staticRenderFns } from "./InventoryStatusItemsReport.vue?vue&type=template&id=4063eda9"
import script from "./InventoryStatusItemsReport.vue?vue&type=script&lang=js"
export * from "./InventoryStatusItemsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports